import { render, staticRenderFns } from "./TreatmentPlans.vue?vue&type=template&id=1edd9d51&scoped=true&"
import script from "./TreatmentPlans.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlans.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlans.vue?vue&type=style&index=0&id=1edd9d51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd9d51",
  null
  
)

export default component.exports